module.exports = __webpack_public_path__ + "4db73bcdd34f88d6b19bded8146e05f4.ttf";